import OpenAI from "openai";

export const OPENAI_MODEL = "gpt-4.1";

export function getOpenAIClient() {
  const apiKey = process.env.REACT_APP_OPENAI_API_KEY;

  if (!apiKey) return null;

  return new OpenAI({
    apiKey,
    dangerouslyAllowBrowser: true,
  });
}